// extracted by mini-css-extract-plugin
export var loadingSpinner = "_41-1";
export var standaloneTable = "_41-0";